import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledCard,
  StyledCardContent,
  StyledCardDesc,
  StyledCardImage,
  StyledCardInner,
  StyledCardMainContent,
  StyledCardReward,
  StyledCardRewards,
  StyledCardTitle,
  StyledContainer,
  StyledFeatures,
  StyledHeader
} from './MGMFeatures.styled';

const MGMFeatures: React.FC = () => {
  const { t } = useI18n('member-get-member');

  const cards = [
    {
      title: t('member-get-member.how-it-works.referring-manfredite.title'),
      image: getPublicPath('/images/memberGetMember/card1.png'),
      desc: t('member-get-member.how-it-works.referring-manfredite.desc'),
      rewards: [
        {
          text: t(
            'member-get-member.how-it-works.referring-manfredite.reward1'
          ),
          icon: getPublicPath('/images/memberGetMember/merch.svg')
        },
        {
          text: t(
            'member-get-member.how-it-works.referring-manfredite.reward2'
          ),
          icon: getPublicPath('/images/memberGetMember/fredcoins10.svg')
        },
        {
          text: t(
            'member-get-member.how-it-works.referring-manfredite.reward3'
          ),
          icon: getPublicPath('/images/memberGetMember/fredcoins10.svg')
        }
      ]
    },
    {
      title: t('member-get-member.how-it-works.referring-company.title'),
      image: getPublicPath('/images/memberGetMember/card2.png'),
      desc: t('member-get-member.how-it-works.referring-company.desc'),
      rewards: [
        {
          text: t('member-get-member.how-it-works.referring-company.reward1'),
          icon: getPublicPath('/images/memberGetMember/fredcoins10.svg')
        },
        {
          text: t('member-get-member.how-it-works.referring-company.reward2'),
          icon: getPublicPath('/images/memberGetMember/fredcoins5.svg')
        }
      ]
    },
    {
      title: t('member-get-member.how-it-works.referred-company.title'),
      image: getPublicPath('/images/memberGetMember/card3.png'),
      desc: t('member-get-member.how-it-works.referred-company.desc'),
      rewards: [
        {
          text: t('member-get-member.how-it-works.referred-company.reward1'),
          icon: getPublicPath('/images/memberGetMember/fredcoins5.svg')
        }
      ]
    }
  ];

  return (
    <StyledContainer>
      <StyledHeader id="features">
        <Heading1 as="h2" editorial>
          {t('member-get-member.how-it-works.title')}
        </Heading1>
        <p>{t('member-get-member.how-it-works.desc')}</p>
        <ButtonLink
          href="https://getmanfred.typeform.com/to/qQt6QXxM"
          target="_blank"
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('member-get-member.how-it-works.cta')}</span>
        </ButtonLink>
      </StyledHeader>
      <StyledFeatures>
        {cards.map((card, index) => (
          <StyledCard key={index}>
            <StyledCardInner>
              <StyledCardContent>
                <StyledCardTitle>
                  {card.title}
                  <img
                    src={getPublicPath(
                      '/images/memberGetMember/card-title-icon.svg'
                    )}
                    alt=""
                  />
                </StyledCardTitle>
                <StyledCardImage>
                  <img src={card.image} alt="" />
                </StyledCardImage>
                <StyledCardMainContent>
                  <StyledCardDesc>{card.desc}</StyledCardDesc>
                  <StyledCardRewards>
                    {card.rewards.map((reward, index) => (
                      <StyledCardReward key={index}>
                        <img src={reward.icon} alt="" />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: reward.text
                          }}
                        ></span>
                      </StyledCardReward>
                    ))}
                  </StyledCardRewards>
                </StyledCardMainContent>
              </StyledCardContent>
            </StyledCardInner>
          </StyledCard>
        ))}
      </StyledFeatures>
    </StyledContainer>
  );
};

export default MGMFeatures;
